import React from "react";
import {TextField} from "@mui/material";
import {RankField} from "../fields";
import {forms, objects} from "@atttomyx/shared-utils";
import {sortingUtils} from "../../utils";

const FileForm = (props) => {
    const { data, onChange : onSync } = props;

    const onChange = (field, value) => {
        const modified = objects.deepCopy(data);

        modified[field] = value;
        modified.valid = modified.fileName
            && modified.ranks && modified.ranks.length > 0
            && sortingUtils.isSortable(modified.order);

        onSync(modified);
    };

    return <div className="file-form">
        <div className="field top-margin">
            <TextField
                required={true}
                label="Name"
                type="text"
                value={forms.sanitizeValue(data.fileName)}
                onChange={(event) => onChange("fileName", event.target.value)}
            />
        </div>
        <div className="field">
            <RankField
                value={forms.sanitizeValue(data.ranks)}
                onChange={(value) => onChange("ranks", value)}
            />
        </div>
        <div className="field">
            <TextField
                required={true}
                label="Index"
                type="number"
                value={forms.sanitizeValue(data.order)}
                onChange={(event) => onChange("order", event.target.value)}
                inputProps={{
                    step: 1,
                    min: 0,
                }}
            />
        </div>
    </div>
}

export default FileForm;
